// extracted by mini-css-extract-plugin
export default {"Menu":"wBbdJ5xg","primary":"JOMWYBMN"};
    if(module.hot) {
      // 1776432169957
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  